import { isMongoId } from '../../helpers';
import { z } from 'zod';

export const ListFeeTemplatesSchema = z.object({
  vehicleId: z.string().refine(isMongoId()),
});
